import request from '@/api/request'

let BASE_URL ="/api/manager/userscheduling";

export function scheduleApplyApi(){
    let url = BASE_URL + '/schedule-apply';

    return request({
        url: url,
        method: 'get'
    })
}

